module.exports = __webpack_public_path__ + "c_static/img/B-1京东-核对店铺.ca19dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/B-1京东-核对店铺.jpg
// module id = LJuH
// module chunks = 33